export default __webpack_public_path__ + "static/media/Flag_of_Jordan.adf4836f.svg";